import { useMutation } from "react-query";
import http from "shared/http";

export interface DownloadResource {
  id: number;
  title: string;
  resourceTier?: string;
  summary?: string;
  categories: string[];
  agencies?: string[];
  roles?: string[];
  isActive?: boolean;

  storageProvider?: string; // AZURE_BLOB, AWS_S3, SHAREPOINT, LOCAL, URL etc.
  storageKey?: string; // e.g. blob name or file path
  fileName?: string; // original file name for download
  mimeType?: string; // e.g. application/pdf
  downloadURL?: string; // when sharepoint or URL provider, the direct download URL or share link
}

export const useUpsertDownloadMutation = () => {
  return useMutation(async (download: DownloadResource) => {
    if (download.id > 0) {
      return await http.putAsync(`admin/downloads/${download.id}`, download);
    }
    return await http.postAsync("admin/downloads", download);
  });
};

export const useDeleteDownloadMutation = () => {
  return useMutation(async (downloadId: number) => {
    return await http.deleteAsync("admin/downloads", downloadId);
  });
};
